import React, { useState } from 'react';
import { TaskList } from '../../types/tasks';
import { useTasks } from '../../context/TasksContext';
import { userName } from '../../utils/taskUsers';
import TaskDialog from './TaskDialog';
import { UserBubble } from './UserBubble';

const ShareDialog: React.FC<{ list: TaskList; members: string[]; onClose: () => void }> = ({ list, members, onClose }) => {
  const { users, me, setMembers } = useTasks();
  const [selected, setSelected] = useState<Set<string>>(new Set(members));
  const [saving, setSaving] = useState(false);

  const toggle = (email: string) =>
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(email)) next.delete(email);
      else next.add(email);
      return next;
    });

  const save = async () => {
    setSaving(true);
    await setMembers(list.id, Array.from(selected));
    setSaving(false);
    onClose();
  };

  const intro =
    list.kind === 'project'
      ? 'People you share with can see and edit the whole project, and show any part of it on their Lists.'
      : list.kind === 'view'
        ? "This card shows part of a project on their Lists. They need to be on the project — if it's yours, sharing here adds them."
        : 'People you share with can see, tick and edit everything on this list.';

  return (
    <TaskDialog
      title={`Share "${list.title || (list.kind === 'project' ? 'Untitled project' : 'Untitled list')}"`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="tk-btn tk-btn-ghost" onClick={onClose}>Cancel</button>
          <button type="button" className="tk-btn tk-btn-primary" onClick={save} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </>
      }
    >
      <p className="tk-muted tk-dialog-intro">{intro}</p>
      <ul className="tk-share-list">
        {users.map((u) => {
          const isOwner = u.email === list.owner_email;
          return (
            <li key={u.email}>
              <label className={`tk-share-row${isOwner ? ' is-owner' : ''}`}>
                <input
                  type="checkbox"
                  checked={isOwner || selected.has(u.email)}
                  disabled={isOwner}
                  onChange={() => toggle(u.email)}
                />
                <UserBubble users={users} email={u.email} size="md" />
                <span className="tk-share-name">
                  {userName(users, u.email)}
                  {u.email === me && <span className="tk-muted"> (you)</span>}
                  <span className="tk-share-email">{u.email}</span>
                </span>
                {isOwner && <span className="tk-chip tk-chip-muted">Owner</span>}
              </label>
            </li>
          );
        })}
      </ul>
    </TaskDialog>
  );
};

export default ShareDialog;
